import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function Menu() {
  const [userData, setUserData] = useState(null);
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [openMenus, setOpenMenus] = useState({}); // Tracks which parent menus are open

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUserData(user);
      if (user) fetchUserData(user.uid);
    });
    return () => unsubscribe();
  }, []);

  const fetchUserData = async (uid) => {
    try {
      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setUsername(docSnap.data().username);
        setRole(docSnap.data().role);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };

  const menuItems = [
    { name: "Home", icon: "fa fa-home", link: "/home" },
    { name: "Approvals", icon: "fa fa-check", link: "/approvals" },
    { name: "Cleaning Rooms", icon: "fa fa-remove", link: "/room-cleaning" },
    { name: "Cleaned Rooms", icon: "fa fa-check", link: "/room-cleaned" },
    {
      name: "Report",
      icon: "fa fa-file",
      subMenu: [
        { name: "Room Type Wise Online", link: "/room-type-wise-online-bookings" },
        { name: "Date Wise Sale", link: "/datewise-sale-report" },
        { name: "DCR Report", link: "/dcr-report" },
        { name: "Receptionist Report", link: "/receptionist-report" },
        { name: "All Booking Report", link: "/all-booking-report" },
        { name: "Payment Mode Wise", link: "/paymode-wise-report" },
        { name: "Booking Type Wise", link: "/booking-type-report" },
        { name: "GST Report", link: "/gst-report" },
        { name: "User Logs", link: "/user-logs" },
        { name: "Login Details", link: "/login-details" },
      ],
    },
    {
      name: "Reservations",
      icon: "fa fa-calendar",
      subMenu: [
        { name: "Live Bookings", link: "/live-bookings" },
        { name: "Checkout History", link: "/checkout-history" },
        { name: "Damage Notes", link: "/damage-notes" },
        { name: "Pending Bookings Notes", link: "/pending-bookings" },
      ],
    },
    {
      name: "OTA & Websites",
      icon: "fa fa-globe",
      subMenu: [
        { name: "OTA Bookings", link: "/ota-bookings" },
        { name: "Website Rooms", link: "/website-rooms" },
        { name: "Website Gallery", link: "/website-gallery" },
      ],
    },
    {
      name: "Master",
      icon: "fa fa-book",
      subMenu: [
        { name: "Room Types", link: "/room-types" },
        { name: "Room Type Images", link: "/room-type-images" },
        { name: "Room Details", link: "/room-details" },
        { name: "Rate Plans", link: "/rate-plans" },
        { name: "Room Tarrifs", link: "/room-tarrif" },
        { name: "Room Services", link: "/room-services" },
        { name: "Payment Modes", link: "/payment-modes" },
        { name: "Booking Types", link: "/booking-types" },
        { name: "User Mgmt", link: "/user-mgmt" },
      ],
    },
  ];

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4" style={{ minHeight: "100vh" }}>
      {/* Brand */}
      <a href="/" className="brand-link" style={{ display: "flex", alignItems: "center", padding: "10px" }}>
        <img
          src={window.location.origin + "/user.jpg"}
          alt="User"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8", width: "35px", height: "35px", marginRight: "10px" }}
        />
        <span className="brand-text font-weight-light">{username || "User"}</span>
      </a>

      {/* Sidebar */}
      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {menuItems.map((item, idx) => (
              <li key={idx} className={`nav-item ${item.subMenu && openMenus[item.name] ? "menu-open" : ""}`}>
                {item.subMenu ? (
                  <>
                    <a
                      href="#0"
                      className="nav-link"
                      onClick={() => toggleMenu(item.name)}
                      style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                      <span>
                        <i className={`nav-icon ${item.icon}`}></i>
                        <p style={{ display: "inline-block", marginLeft: "5px" }}>{item.name}</p>
                      </span>
                      <i className={`fa fa-angle-${openMenus[item.name] ? "down" : "left"}`}></i>
                    </a>
                    <ul className="nav nav-treeview" style={{ display: openMenus[item.name] ? "block" : "none" }}>
                      {item.subMenu.map((sub, subIdx) => (
                        <li className="nav-item" key={subIdx}>
                          <a href={sub.link} className="nav-link">
                            <i className="fa fa-circle nav-icon" style={{ fontSize: "8px" }}></i>
                            <p>{sub.name}</p>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a href={item.link} className="nav-link">
                    <i className={`nav-icon ${item.icon}`}></i>
                    <p>{item.name}</p>
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Menu;
